var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserTodo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user_3_",
    "data-name": "user (3)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26883",
    "data-name": "Path 26883",
    d: "M12.938,3.125a2.813,2.813,0,1,1-2.812,2.813,2.813,2.813,0,0,1,2.813-2.812m0-1.125a3.938,3.938,0,1,0,3.938,3.938A3.937,3.937,0,0,0,12.938,2Z",
    transform: "translate(-3.938 -0.875)",
    fill: "#101010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26884",
    "data-name": "Path 26884",
    d: "M17.25,24.75H16.125V21.938a2.812,2.812,0,0,0-2.813-2.812H9.938a2.812,2.812,0,0,0-2.812,2.813V24.75H6V21.938A3.938,3.938,0,0,1,9.938,18h3.375a3.937,3.937,0,0,1,3.938,3.938Z",
    transform: "translate(-2.625 -7.875)",
    fill: "#101010"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 18,
    height: 18,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTodo);
export default __webpack_public_path__ + "static/media/user-todo.73dfc72c7a1248b429fa925b745ead0a.svg";
export { ForwardRef as ReactComponent };